import ControllerBase from '../../../../global/js/ControllerBase';

export interface FilterProps {
	active: number;
	activeCounter: HTMLElement;
	drop: HTMLElement;
	inputs: NodeListOf<Element>;
	labels: string[];
	idList: string[];
	labelContainer: HTMLElement;
	open: boolean;
	hiddenInput: HTMLInputElement;
	wrapper: Element;
	singleOptions: boolean;
}

export default class ControllerAccordionFilter extends ControllerBase {
	private filters: FilterProps[] = [];

	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private init() {
		const change = new Event('change');
		const wrappers = this.$element.querySelectorAll('.m-filter-accordion-wrapper');
		for (const wrapper of wrappers) {
			const drop = wrapper.querySelector('.m-filter-accordion-head') as HTMLElement;
			const labelContainer = drop.querySelector('.left-content') as HTMLElement;
			const activeCounter = wrapper.querySelector('.checked-filters') as HTMLElement;
			const inputs = wrapper.querySelectorAll('input[type="checkbox"]');
			const hiddenInput = wrapper.querySelector('input[type="hidden"]') as HTMLInputElement;
			const singleOptions = !!wrapper.getAttribute('data-single-options');
			this.filters.push({
				active: 0,
				activeCounter,
				drop,
				inputs,
				labels: [],
				idList: [],
				labelContainer,
				open: false,
				hiddenInput,
				wrapper,
				singleOptions: singleOptions
			});
			const key = this.filters.length - 1;
			drop.addEventListener('click', e => {
				this.filters[key].open = !this.filters[key].open;
				wrapper.setAttribute('data-opened', this.filters[key].open ? "true" : "false");
			});
			for (const el of inputs) {
				const checkbox = <HTMLInputElement>el;
				checkbox?.addEventListener('change', () => {
					const text = checkbox.getAttribute('data-label') || '';
					const id = checkbox.getAttribute('data-id') || '';
					const index = this.filters[key].labels.indexOf(text);
					if (this.filters[key].singleOptions) {
						const inputsChecked = wrapper.querySelectorAll('input[type="checkbox"]:checked');
						if(inputsChecked.length) {
							for (const check of inputsChecked) {
								const checky = <HTMLInputElement>check;
								if (checky.value != id) {
									checky.checked = false;
									this.filters[key].labels.splice(0, 1);
									this.filters[key].idList.splice(0, 1);
								} else {
									this.filters[key].labels.push(text);
									this.filters[key].idList.push(id);
								}
							}
						} else {
							checkbox.checked = true;
						}
					} else {
						if (checkbox.checked) {
							this.filters[key].active++;
							if (index < 0) {
								this.filters[key].labels.push(text);
								this.filters[key].idList.push(id);
							}
						} else {
							this.filters[key].active--;
							this.filters[key].labels.splice(index, 1);
							this.filters[key].idList.splice(index, 1);
						}
					}
					if (this.filters[key].active) {
						this.filters[key].activeCounter.innerHTML = `+${this.filters[key].active}`
						activeCounter.classList.add('active');
					} else {
						this.filters[key].activeCounter.innerHTML = '';
						activeCounter.classList.remove('active');
					}
					this.filters[key].hiddenInput.value = this.filters[key].idList.length ? JSON.stringify(this.filters[key].idList) : '';
					this.filters[key].labelContainer.innerHTML = `${this.filters[key].labels.join(', ')}`;
				});
			}
			const inputsChecked = wrapper.querySelectorAll('input[type="checkbox"]:checked');
			if(inputsChecked.length) {
				for (const check of inputsChecked) {
					const checkbox = <HTMLInputElement>check;
					checkbox.dispatchEvent(change);
				}
			}
		}
	}
}
